import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { StrapiApiService } from 'app/shared/services/strapi-api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'learn',
    templateUrl:'./learn.component.html',
    styleUrls: ['./learn.component.scss']
})
export class LearnComponent {

  
  lmsData:any=[]
  userId:any
  userData:any;
  lms_id:string
  imgUrl= environment.apiUrls.rbUrl
  courses:any=[]
  course_id:any
  default_courses:any=[]
  user_detail:any
  enrollment:any
  constructor(private strapiService: StrapiApiService,private apiService:ApiService,
              private router:Router,private spinner: NgxSpinnerService,public toastr: ToastrService,) {
        let localData=JSON.parse(localStorage.getItem('user'))
        this.user_detail = localData
        this.userId=localData.id
        this.getStudentById(this.userId)
        this.course_id = localStorage.getItem('course-id')
   }

  ngOnInit(): void {
    this.getCourseByUser(this.userId)
    this.getDefaultCourseList()
    this.getCurrentUserEnrollment()
  }
    getCurrentUserEnrollment(){
      this.apiService.getEnrollByUserId(this.userId).subscribe((res:any)=>{
        this.enrollment = res?.data
        console.log('====>>>> en',this.enrollment)
      })
    }
  getStudentById(id: any){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getStudentById(id).subscribe((res:any)=>{
      this.spinner.hide()
      this.userData=res?.data
      if(res?.data?.course?.lsm_ids){
        this.lms_id=res.data.course.lsm_ids
        this.course_id = this.userData?.course?._id
      }
    })
  }
  getLmsV1ById(id) {
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });

      this.strapiService.getLmsV1ById(id).subscribe((res: any) => {
      this.spinner.hide()
      this.lmsData = res;
    })
  }
  selectTag(data: any) {
    var name = data;
    name = name.toLowerCase();
    name = name.replace(/ /g, "-");
    name = name.replace(/\?/g, "-");
    if(this.lmsData.id){
      this.router.navigate([`/lms/detail/${name}`, this.lmsData.id])
    }
  }
  getCourseByUser(id){
    this.apiService.getEnrollByUserId(id).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.userData=res?.data
        this.courses=this.userData.map(item => item.enrolment.course_id[0]);  
      }
    })
  }
  getDefaultCourseList(){
    this.apiService.getDefaultCourse().subscribe((res:any)=>{
      this.default_courses = res?.data
    })
  }
}
